import React from "react";
import { Avatar, Dropdown } from "antd";
import {toast} from "react-toastify";
import "./AppHeader.css";
import useAuth from "../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";

export default function AppAvatar() {
    const { auth } = useAuth();
    const navigate = useNavigate();

    const user = auth.getUser();
    const fullName = `${user?.firstname[0]} ${user?.lastname[0]}`;

    const logout = () => {
        try {
            auth.logout();
            navigate("/");
            // TODO: replace with a better process
            window.location.reload();
        } catch (error) {
            console.error("Logout failed:", error);
            toast("Logout failed", { type: "error" });
        }
    };

    const items = [
        {
            label: (
                <div onClick={logout}>
                    Logout
                </div>
            ),
            key: "0",
        },
    ];

    const url = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpUyY77jqPWaZyIzr1aP-nErZUNeuyHcgoyQ&usqp=CAU";

    return (
        <Dropdown menu={{ items }} trigger={["click"]} overlayClassName="AppProfile">
            <Avatar>{fullName}</Avatar>
        </Dropdown>
    );
}
